(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[18001,65250],{

/***/ 18001:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ CampLejeuneApplicationWrapper; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./node_modules/next/head.js
var head = __webpack_require__(9008);
var head_default = /*#__PURE__*/__webpack_require__.n(head);
// EXTERNAL MODULE: ./src/components/shared/header/index.tsx
var header = __webpack_require__(74206);
// EXTERNAL MODULE: ./src/hooks/useModalContext.tsx
var useModalContext = __webpack_require__(67379);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./src/components/shared/blogPost/sideWidget/mobile/index.tsx + 1 modules
var mobile = __webpack_require__(8281);
// EXTERNAL MODULE: ./node_modules/next/router.js
var router = __webpack_require__(11163);
// EXTERNAL MODULE: ./src/styles/variables/camplejeuneapplicationVariables.module.scss
var camplejeuneapplicationVariables_module = __webpack_require__(4420);
var camplejeuneapplicationVariables_module_default = /*#__PURE__*/__webpack_require__.n(camplejeuneapplicationVariables_module);
;// CONCATENATED MODULE: ./src/components/basecamplejeune/logo/index.tsx


function BaseCamplejeuneLogo() {
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("svg", {
        xmlns: "http://www.w3.org/2000/svg",
        width: "326",
        height: "40",
        fill: "none",
        viewBox: "0 0 326 40",
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("g", {
                clipPath: "url(#clip0_2_184)",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E2F5C",
                        d: "M31.13 21.343a14.206 14.206 0 01-1.624 6.614s-.373.709-.593 1.042c-.22.333-.431.709-.68 1l-.183.247-.197.241-.103.128-.102.113-.205.241c-.066.078-.14.15-.212.227-.074.078-.14.156-.213.227-.073.07-.292.298-.446.432l-.226.213-.227.199-.461.375-.117.092-.117.085-.227.17c-.985.81-2.09 1.472-3.278 1.964l-4.938 2.027-4.873-2.006a9.913 9.913 0 01-.944-.467h-.036l-.278-.121a.996.996 0 00-.154-.07l-.16-.086a7.457 7.457 0 01-.732-.39l-.417-.24-.44-.277-.453-.312-.293-.192-.117-.085-.117-.092-.46-.376-.227-.198-.227-.213c-.154-.134-.293-.283-.446-.432-.154-.149-.14-.149-.213-.227-.073-.078-.146-.149-.212-.227l-.175-.24-.103-.114-.102-.128-.227-.234-.183-.248a12.103 12.103 0 01-.68-1c-.205-.332-.586-1.041-.586-1.041a14.123 14.123 0 01-1.631-6.614l.088-13.227-1.537-.553.388 16.36s3.431 10.846 10.184 12.76c6.753 1.914 4.148 2.084 4.148 2.084l4.046-1.326s8.992-3.07 9.899-5.983c.907-2.913 1.887-6.38 1.887-6.38l1.464-4.961-1.902 1.283"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E2F5C",
                        d: "M11.618 33.861l-.132-.063c-.088-.043-.22-.1-.38-.185l-.264-.134-.153-.078-.161-.092-.132-.071c.256.156.52.304.732.44l.314.127.176.056z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BF2628",
                        d: "M33.625 21.747l-.102-15.013-.842-.276a40.477 40.477 0 00-6.738-1.567c.324.401.62.823.885 1.262.315.5.591 1.02.827 1.56 1.143.219 2.274.495 3.387.829l.088 13.205a14.207 14.207 0 01-1.624 6.614s-.373.709-.593 1.042c-.22.333-.431.709-.68 1l-.183.247-.198.241-.102.128-.102.113-.205.241c-.066.078-.14.15-.212.227-.074.078-.14.156-.213.227-.073.07-.292.298-.446.432l-.227.213-.226.198-.461.376-.117.092-.117.085-.227.17c-.985.81-2.09 1.472-3.278 1.964l-4.938 2.056-4.873-2.006a9.899 9.899 0 01-.966-.461h-.073l-.278-.12a1.018 1.018 0 00-.153-.072l-.161-.077a9.568 9.568 0 01-.732-.397l-.417-.241-.439-.277-.453-.312-.235-.198-.117-.085-.117-.078-.46-.376-.227-.198-.227-.213c-.154-.135-.293-.284-.447-.433-.153-.148-.139-.148-.212-.226-.073-.078-.146-.15-.212-.227l-.175-.255-.103-.114-.102-.127-.198-.241-.183-.248a12.103 12.103 0 01-.68-1c-.205-.333-.585-1.042-.585-1.042a14.125 14.125 0 01-1.661-6.642L2.583 8.52a34.556 34.556 0 013.424-.8c.223-.54.487-1.064.79-1.567.266-.435.562-.851.885-1.248-2.29.33-4.544.854-6.738 1.567l-.842.276-.102 15a16.632 16.632 0 002.846 9.313c1.834 2.757 4.476 4.919 7.587 6.21l6.38 2.637 6.38-2.637c3.106-1.284 5.748-3.436 7.586-6.181a16.63 16.63 0 002.846-9.343z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E2F5C",
                        d: "M5.78 10.122a11.93 11.93 0 00-.11 1.46 3.166 3.166 0 00-.395 1.524c0 1.156.914 2.042 3.058 2.95.176.552.57 2.126.673 2.58a4.628 4.628 0 001.054 1.594v.312l.102 1.05.161 1.63c-2.136.758-3.497 1.892-3.497 3.154.008.415.146.818.395 1.155a4.257 4.257 0 01-1.214-1.665 8.69 8.69 0 00-1.39.843c.16.376.343.78.563 1.184.22.404.38.709.6 1.006.058.078.11.17.168.249l.176.248.087.12.088.12.183.242.198.234c.065.078.124.163.197.234.073.07.264.304.403.446l.212.22.212.205.22.213a19.877 19.877 0 002.472 1.808l.132.07.16.093.154.078.264.134c.16.085.293.142.38.185l.132.063-.139-.063-.315-.128c.313.17.636.325.966.46l4.85 2.014 2.474-1.02 3.043-1.51.27-.135.147-.078.161-.093c.22-.12.461-.262.732-.432l.402-.262.417-.298.424-.34.213-.177.11-.093.11-.092c.138-.127.284-.255.423-.397l.213-.205.212-.22c.139-.142.27-.298.402-.446.132-.15.132-.156.198-.234l.197-.234.183-.241.095-.12.08-.121.176-.248c.059-.078.11-.17.169-.248.219-.334.417-.71.6-1.007.182-.298.402-.808.563-1.184a8.692 8.692 0 00-1.398-.843 4.259 4.259 0 01-1.229 1.666c.25-.338.388-.74.395-1.156 0-1.262-1.36-2.396-3.497-3.154l.161-1.63.14-1.05v-.312c.456-.457.811-1 1.046-1.595.102-.446.497-2.027.673-2.58 2.143-.907 3.058-1.793 3.058-2.948a3.167 3.167 0 00-.403-1.524 12.386 12.386 0 00-1.821-6.267c-.424-.67-.914-1.3-1.464-1.878A10.477 10.477 0 0021.105.9 10.777 10.777 0 0016.79 0c-1.488 0-2.959.307-4.315.9a10.477 10.477 0 00-3.55 2.538c-.55.578-1.04 1.207-1.464 1.878a12.07 12.07 0 00-1.682 4.806zm16.022 13.185l-.307 3.112c-.608.708-3.015 1.765-4.683 2.353-1.668-.588-4.075-1.645-4.682-2.353l-.27-3.112-.14-1.333c.518.493.985 1.031 1.398 1.61.042.082.094.16.153.233l1.595 3.154-.117-2.325c1.39.237 2.81.237 4.2 0l-.117 2.325 1.595-3.154c.06-.072.11-.15.153-.234.413-.578.88-1.116 1.398-1.609l-.176 1.333zm.161-5.848c-.256.312-.46.524-.46.524a13.302 13.302 0 01-.77 3.545c-.198.305-.413.601-.643.886-.63 1.063-1.91.921-3.065.921a1.03 1.03 0 01-.205 0 1.032 1.032 0 01-.205 0c-1.156 0-2.436.142-3.065-.921-.23-.285-.445-.58-.644-.886a13.3 13.3 0 01-.732-3.545s-.205-.212-.46-.524a5.418 5.418 0 01-1.062-1.78 12.029 12.029 0 012.283-.481 22.581 22.581 0 012.59-.178l.102 1.142.38-1.184c.095-.245.21-.482.345-.709a.733.733 0 01.512-.22.787.787 0 01.52.22c.129.228.241.465.336.709l.387 1.184.096-1.142c.866.01 1.73.069 2.59.178.775.086 1.54.248 2.282.482a5.425 5.425 0 01-1.112 1.814v-.035zm5.48-4.927c-1.785-1.417-3.812-1.602-5.75-1.602-.732 0-1.464 0-2.29.064-.827.064-1.69.12-2.59.12-.9 0-1.756 0-2.59-.077-.835-.078-1.552-.064-2.29-.064-1.94 0-3.966.198-5.744 1.602 1.464-1.914 3.922-2.261 6.146-2.261.732 0 1.53 0 2.275.063.747.064 1.463.064 2.195.064.732 0 1.463-.035 2.195-.064.732-.028 1.53-.063 2.275-.063 2.239-.014 4.683.333 6.168 2.218zM9.357 4.46a9.819 9.819 0 013.355-2.444 10.107 10.107 0 014.1-.868c1.416 0 2.814.296 4.101.868a9.819 9.819 0 013.355 2.444c.356.39.686.801.987 1.233a12.69 12.69 0 00-1.792-1.503 11.573 11.573 0 00-6.65-2.09c-2.39 0-4.717.731-6.65 2.09A12.69 12.69 0 008.37 5.692c.3-.432.63-.844.987-1.233z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E2F5C",
                        d: "M15.379 17.997c.261-.007.523.024.775.093.429.13.888.13 1.317 0 .252-.07.514-.1.776-.093a.239.239 0 00.156-.048.226.226 0 00.085-.136 1.169 1.169 0 00-.264-.992.392.392 0 00-.124-.071l-.08-.043v.092a.428.428 0 01-.08.376c-.323.26-.73.404-1.15.404-.42 0-.826-.143-1.148-.404a.434.434 0 01-.08-.376v-.092l-.044.078a.39.39 0 00-.125.071 1.16 1.16 0 00-.256.992c.015.05.048.091.092.118a.225.225 0 00.15.031zM8.128 31.614l.11.092.11.093.212.177c.146.12.292.227.424.34l.417.298.403.262.592.362a19.885 19.885 0 01-2.473-1.808l.205.184zM16.813 20.847a12.117 12.117 0 01-2.107-.248l-.096-.05.505 1.212a8.804 8.804 0 011.654-.24 8.794 8.794 0 011.646.24l.505-1.212-.103.05c-.66.14-1.33.222-2.005.248zM17.625 19.181a4.22 4.22 0 00-.813.177 4.22 4.22 0 00-.812-.177c-.446 0-1.675.447-1.675.766v.07H19.3v-.07c0-.326-1.23-.752-1.675-.766z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BF2628",
                        d: "M6.021 21.605l1.573.802-.3-1.702L8.567 19.5l-1.763-.248-.783-1.545-.79 1.545-1.763.248 1.28 1.205-.307 1.702 1.58-.802zM28.496 19.252l-.782-1.545-.79 1.545-1.764.248 1.273 1.205-.3 1.702 1.58-.802 1.573.802-.3-1.702L30.26 19.5l-1.763-.248z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E2F5C",
                        d: "M54.059 21.747a5.906 5.906 0 012.348 2.127c.576.925.87 1.989.849 3.07a5.771 5.771 0 01-.489 2.47 5.937 5.937 0 01-1.501 2.051 6.995 6.995 0 01-4.865 1.808h-9.797V11.115h9.072c1.762-.04 3.47.59 4.756 1.758a5.74 5.74 0 011.461 1.986 5.58 5.58 0 01.478 2.394 5.151 5.151 0 01-.57 2.53 5.34 5.34 0 01-1.742 1.964zm-4.39-7.244H44.35v5.827h5.32a2.88 2.88 0 001.137-.208c.36-.145.686-.362.955-.636a2.977 2.977 0 00.848-2.073c0-.77-.304-1.512-.848-2.074a2.83 2.83 0 00-.953-.629 2.903 2.903 0 00-1.133-.207h-.007zm.732 15.318c.41.007.819-.07 1.197-.227.378-.156.718-.388.998-.68.578-.595.9-1.38.9-2.198a3.15 3.15 0 00-.9-2.197 2.93 2.93 0 00-.999-.677 3.009 3.009 0 00-1.196-.223h-6.043v6.202H50.4zM73.388 17.416h3.526v15.822h-3.526v-2.276c-.64.88-1.5 1.588-2.5 2.06-.998.47-2.104.689-3.214.634a7.864 7.864 0 01-3.143-.615 7.651 7.651 0 01-2.607-1.81 8.564 8.564 0 01-2.384-5.908c0-2.19.851-4.299 2.384-5.908a7.685 7.685 0 012.61-1.795 7.897 7.897 0 013.14-.608 6.82 6.82 0 013.206.626 6.59 6.59 0 012.508 2.032v-2.254zM64.536 28.95a5.418 5.418 0 003.69 1.44 5.418 5.418 0 003.692-1.44 5.227 5.227 0 001.47-3.622 5.227 5.227 0 00-1.47-3.622 5.418 5.418 0 00-3.691-1.44 5.418 5.418 0 00-3.691 1.44 5.227 5.227 0 00-1.471 3.622c0 1.344.525 2.638 1.47 3.622zM84.099 21.747c.008.273.1.538.265.76.164.222.392.392.657.488.704.339 1.439.617 2.195.83l2.553.758a4.54 4.54 0 012.195 1.474 4.465 4.465 0 01.88 3.337 4.543 4.543 0 01-1.773 2.986 7.638 7.638 0 01-4.587 1.269 8.316 8.316 0 01-4.148-.986 5.8 5.8 0 01-2.51-2.721l3.037-1.709c.565 1.522 1.772 2.283 3.621 2.283 1.851 0 2.78-.596 2.78-1.772a1.389 1.389 0 00-.266-.743 1.456 1.456 0 00-.634-.49c-.7-.356-1.436-.644-2.195-.858l-2.597-.773a4.599 4.599 0 01-2.195-1.418 3.814 3.814 0 01-.9-2.608 4.14 4.14 0 01.41-1.975 4.281 4.281 0 011.302-1.57 6.73 6.73 0 014.295-1.304 7.354 7.354 0 013.607.872 5.94 5.94 0 012.429 2.453l-2.97 1.616a3.38 3.38 0 00-.86-1.047 3.505 3.505 0 00-1.212-.64 3.576 3.576 0 00-2.691.27 1.374 1.374 0 00-.518.517c-.121.214-.18.457-.17.701zM98.336 26.78a4.346 4.346 0 001.8 2.765c1.008.662 2.206 1 3.424.964a4.913 4.913 0 002.371-.45 4.746 4.746 0 001.843-1.514l2.926 1.645c-1.609 2.296-3.992 3.447-7.147 3.452a9.033 9.033 0 01-3.468-.544 8.82 8.82 0 01-2.97-1.817 8.034 8.034 0 01-1.861-2.734 7.829 7.829 0 01-.583-3.227 7.91 7.91 0 01.582-3.205 8.116 8.116 0 011.832-2.728 8.321 8.321 0 012.843-1.826 8.534 8.534 0 013.361-.563 7.835 7.835 0 013.215.597 7.625 7.625 0 012.66 1.849 8.308 8.308 0 012.297 5.911c-.01.475-.054.949-.131 1.418l-12.994.007zm0-2.786h9.599a4.377 4.377 0 00-1.553-2.825 4.648 4.648 0 00-3.115-1.066 5.044 5.044 0 00-3.27 1.049 4.649 4.649 0 00-1.69 2.842h.03z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#BF2628",
                        d: "M127.886 33.649a11.975 11.975 0 01-4.601-.79 11.69 11.69 0 01-3.909-2.48 11.272 11.272 0 01-2.588-3.77 10.986 10.986 0 01-.849-4.45 11.297 11.297 0 011.599-5.701 11.755 11.755 0 014.295-4.192 12.236 12.236 0 015.872-1.591c2.066-.03 4.105.462 5.917 1.425a10.539 10.539 0 014.097 3.863l-3.263 1.829a6.719 6.719 0 00-2.663-2.609 7.916 7.916 0 00-3.907-.964 8.17 8.17 0 00-3.206.523 7.968 7.968 0 00-2.72 1.724 8.358 8.358 0 00-2.259 5.696c0 2.104.805 4.133 2.259 5.696a8.647 8.647 0 004.728 2.186 8.768 8.768 0 005.156-.904 6.433 6.433 0 002.649-2.615l3.204 1.807a10.434 10.434 0 01-4.068 3.878 11.82 11.82 0 01-5.743 1.439zM153.492 17.416h3.527v15.822h-3.527v-2.276a6.53 6.53 0 01-2.499 2.06 6.763 6.763 0 01-3.214.634 7.867 7.867 0 01-3.144-.615 7.658 7.658 0 01-2.607-1.81 8.563 8.563 0 01-2.384-5.908c0-2.19.851-4.299 2.384-5.908a7.687 7.687 0 012.611-1.795 7.9 7.9 0 013.14-.608 6.818 6.818 0 013.205.626 6.582 6.582 0 012.508 2.032v-2.254zM144.64 28.95a5.418 5.418 0 003.691 1.44 5.418 5.418 0 003.691-1.44 5.228 5.228 0 001.471-3.622 5.228 5.228 0 00-1.471-3.622 5.418 5.418 0 00-3.691-1.44 5.418 5.418 0 00-3.691 1.44 5.228 5.228 0 00-1.471 3.622c0 1.344.526 2.638 1.471 3.622zM178.96 17.005a6.061 6.061 0 012.43.405c.772.299 1.47.753 2.047 1.332a6.448 6.448 0 011.698 4.685v9.81h-3.541v-9.59a3.578 3.578 0 00-.849-2.545 2.982 2.982 0 00-1.058-.696c-.4-.156-.83-.225-1.261-.204-.485-.021-.97.06-1.418.241-.449.18-.852.453-1.179.801a4.46 4.46 0 00-.966 3.133v8.86h-3.512v-9.59a3.695 3.695 0 00-.797-2.545 2.843 2.843 0 00-1.028-.7 2.916 2.916 0 00-1.24-.2 3.476 3.476 0 00-1.426.25 3.383 3.383 0 00-1.186.806 4.32 4.32 0 00-1.017 3.12v8.86h-3.548V17.416h3.526v1.9a5.16 5.16 0 012.013-1.765 5.354 5.354 0 012.655-.546 5.126 5.126 0 012.689.602 4.92 4.92 0 011.949 1.893 5.446 5.446 0 012.155-1.917 5.658 5.658 0 012.864-.578zM198.165 17.005a7.882 7.882 0 013.138.615 7.673 7.673 0 012.605 1.802 8.563 8.563 0 012.384 5.909c0 2.19-.851 4.299-2.384 5.908a7.656 7.656 0 01-2.606 1.799 7.876 7.876 0 01-3.137.61 6.768 6.768 0 01-3.214-.63 6.531 6.531 0 01-2.5-2.056v8.57h-3.541V17.416h3.534v2.276a6.534 6.534 0 012.503-2.057 6.77 6.77 0 013.218-.63zm-4.251 11.944a5.418 5.418 0 003.691 1.44 5.418 5.418 0 003.691-1.44 5.228 5.228 0 001.471-3.622 5.228 5.228 0 00-1.471-3.622 5.418 5.418 0 00-3.691-1.44 5.418 5.418 0 00-3.691 1.44 5.25 5.25 0 00-1.463 3.622 5.25 5.25 0 001.463 3.622z"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#1E2F5C",
                        d: "M215.109 29.757h9.306v3.48h-13.059V11.116h3.753v18.642zM229.215 26.78a4.345 4.345 0 001.799 2.765 5.992 5.992 0 003.432.964 4.91 4.91 0 002.37-.445 4.746 4.746 0 001.844-1.512l2.926 1.645c-1.617 2.296-3.995 3.452-7.155 3.452a8.97 8.97 0 01-3.466-.54A8.755 8.755 0 01228 31.29a8.255 8.255 0 01-2.425-4.3 8.088 8.088 0 01.492-4.876 8.395 8.395 0 013.239-3.762 8.79 8.79 0 014.862-1.346 7.833 7.833 0 013.226.589 7.617 7.617 0 012.67 1.85 8.282 8.282 0 012.254 5.911c-.011.475-.055.949-.132 1.418l-12.971.007zm0-2.786h9.598a4.362 4.362 0 00-1.549-2.828 4.635 4.635 0 00-3.118-1.063 4.85 4.85 0 00-3.238 1.027 4.566 4.566 0 00-1.693 2.864zM245.873 33.868V17.416h3.527v16.452c0 4.39-2.232 6.425-6.695 6.104v-3.29c.418.13.863.149 1.291.057a2.507 2.507 0 001.145-.581c.322-.288.559-.654.688-1.06.129-.405.144-.837.044-1.25v.02zm3.344-19.471a2.246 2.246 0 01-2.766.22 2.127 2.127 0 01-.863-1.158 2.064 2.064 0 01.086-1.425c.198-.451.55-.822.997-1.05.447-.23.963-.301 1.458-.204.496.097.942.356 1.263.735a2.083 2.083 0 01.324 2.18 2.14 2.14 0 01-.499.702zM256.292 26.78a4.309 4.309 0 001.792 2.765 5.99 5.99 0 003.431.964 4.924 4.924 0 002.37-.447 4.75 4.75 0 001.844-1.51l2.927 1.645c-1.617 2.296-3.995 3.452-7.155 3.452a8.964 8.964 0 01-3.466-.54 8.745 8.745 0 01-2.965-1.82 8.255 8.255 0 01-2.425-4.3 8.08 8.08 0 01.492-4.876 8.392 8.392 0 013.238-3.762 8.795 8.795 0 014.862-1.346 7.827 7.827 0 013.226.589 7.612 7.612 0 012.671 1.85 8.281 8.281 0 012.253 5.911c-.01.475-.054.949-.131 1.418l-12.964.007zm-.037-2.786h9.599a4.363 4.363 0 00-1.55-2.828 4.635 4.635 0 00-3.118-1.063 4.847 4.847 0 00-3.237 1.027 4.567 4.567 0 00-1.694 2.864zM283.522 17.416h3.527v15.822h-3.527V31.21c-1.068 1.624-2.751 2.439-5.063 2.439a6.185 6.185 0 01-2.459-.406 6.027 6.027 0 01-2.077-1.338 6.55 6.55 0 01-1.36-2.22 6.386 6.386 0 01-.374-2.558v-9.71h3.527v9.363c-.033.495.038.99.207 1.459.17.467.435.897.781 1.263.358.324.779.575 1.239.738.46.163.949.235 1.438.212a4.139 4.139 0 001.625-.26c.518-.193.988-.489 1.382-.867a4.663 4.663 0 00.923-1.605 4.58 4.58 0 00.219-1.826l-.008-8.478zM299.749 17.005a6.216 6.216 0 012.461.404c.782.299 1.492.753 2.083 1.333a6.571 6.571 0 011.355 2.222c.296.82.422 1.688.371 2.555v9.719h-3.526v-9.364a3.535 3.535 0 00-.203-1.455 3.617 3.617 0 00-.778-1.26 3.6 3.6 0 00-1.237-.743 3.697 3.697 0 00-1.44-.207 4.155 4.155 0 00-1.62.258 4.054 4.054 0 00-1.38.862 4.624 4.624 0 00-1.141 3.43v8.507h-3.534v-15.85h3.534v2.027c1.031-1.63 2.751-2.438 5.055-2.438zM312.589 26.78a4.31 4.31 0 001.793 2.765 5.989 5.989 0 003.431.964 4.92 4.92 0 002.391-.437 4.75 4.75 0 001.859-1.52l2.927 1.645c-1.617 2.296-3.995 3.452-7.155 3.452a8.967 8.967 0 01-3.466-.54 8.745 8.745 0 01-2.965-1.82 8.245 8.245 0 01-2.425-4.302 8.072 8.072 0 01.494-4.877 8.388 8.388 0 013.241-3.762 8.795 8.795 0 014.865-1.343 7.822 7.822 0 013.222.59 7.613 7.613 0 012.667 1.849 8.286 8.286 0 012.254 5.911c-.011.475-.055.949-.132 1.418l-13.001.007zm-.036-2.786h9.598a4.362 4.362 0 00-1.549-2.828 4.635 4.635 0 00-3.118-1.063 5.033 5.033 0 00-3.263 1.049 4.683 4.683 0 00-1.668 2.842z"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsx)("defs", {
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("clipPath", {
                    id: "clip0_2_184",
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("path", {
                        fill: "#fff",
                        d: "M0 0H325.714V40H0z"
                    })
                })
            })
        ]
    });
}
/* harmony default export */ var logo = (BaseCamplejeuneLogo);

;// CONCATENATED MODULE: ./src/components/layouts/basecamplejeuneWrapper.tsx










const Modal = dynamic_default()(()=>__webpack_require__.e(/* import() */ 84043).then(__webpack_require__.bind(__webpack_require__, 18740)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(18740)
            ]
    }
});
const Footer = dynamic_default()(()=>__webpack_require__.e(/* import() */ 60681).then(__webpack_require__.bind(__webpack_require__, 31701)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(31701)
            ]
    }
});
const CloseIcon = dynamic_default()(()=>__webpack_require__.e(/* import() */ 69655).then(__webpack_require__.bind(__webpack_require__, 69655)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(69655)
            ]
    }
});
const TermsAndConditions = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(10761), __webpack_require__.e(14777)]).then(__webpack_require__.bind(__webpack_require__, 10761)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(10761)
            ]
    }
});
const PrivacyPolicy = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(57079), __webpack_require__.e(25591)]).then(__webpack_require__.bind(__webpack_require__, 57079)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(57079)
            ]
    }
});
function CampLejeuneApplicationWrapper({ children , footerBgColor  }) {
    const { modal , closeModal  } = (0,useModalContext/* useModal */.d)();
    const { query  } = (0,router.useRouter)();
    const handleClose = ()=>{
        closeModal();
    };
    const { active: modalActive , content: modalContent  } = modal;
    const getModalContent = ()=>{
        switch(modalContent){
            case "privacy":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(PrivacyPolicy, {
                    category: "Camp Lejeune",
                    domain: "BaseCampLejeune.com"
                });
            case "terms":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(TermsAndConditions, {
                    category: "Camp Lejeune",
                    domain: "BaseCampLejeune.com"
                });
            case "sideWidget":
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(mobile/* default */.Z, {});
            default:
                return null;
        }
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)((head_default()), {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.googleapis.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        rel: "preconnect",
                        href: "https://fonts.gstatic.com"
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("link", {
                        href: "https://fonts.googleapis.com/css2?family=Poppins:wght@300;500;700&display=swap",
                        rel: "stylesheet"
                    })
                ]
            }),
            /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
                style: {
                    fontFamily: `'Poppins', sans-serif`
                },
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(header["default"], {
                        slogan: "Get Maximum Justice for Your Camp Lejeune Injuries",
                        textColor: (camplejeuneapplicationVariables_module_default()).offerCallNumber,
                        stickyStyle: {
                            stickTitleColor: (camplejeuneapplicationVariables_module_default()).stickTitleColor,
                            stickBtnTxtColor: (camplejeuneapplicationVariables_module_default()).stickBtnTxtColor,
                            stickBtnBgColor: (camplejeuneapplicationVariables_module_default()).stickBtnBgColor,
                            stickBtnBorderColor: (camplejeuneapplicationVariables_module_default()).stickBtnBorderColor
                        },
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(logo, {})
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)("main", {
                        className: `max-w-7xl mx-auto block px-4vw lg:px-4 ${query.ts ? "withTS" : "withoutTS"}`,
                        children: children
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Footer, {
                        bgColor: footerBgColor
                    }),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Modal, {
                        onClose: handleClose,
                        active: modalActive,
                        closeIcon: /*#__PURE__*/ (0,jsx_runtime.jsx)(CloseIcon, {}),
                        backdropClosable: true,
                        modalStyles: {
                            display: "flex",
                            flexDirection: "column",
                            maxHeight: modalContent === "sideWidget" ? "80vh" : "100%"
                        },
                        modalClassName: "h-[90vh] rounded",
                        bodyStyles: {
                            overflowY: "scroll"
                        },
                        width: 900,
                        header: modalContent === "privacy" ? "Privacy Policy" : modalContent === "terms" ? "Terms and Conditions" : modalContent === "sideWidget" ? "Contents" : undefined,
                        children: getModalContent()
                    })
                ]
            })
        ]
    });
}


/***/ }),

/***/ 74206:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "default": function() { return /* binding */ Header; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(67294);
/* harmony import */ var _hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(88737);
/* harmony import */ var _components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(10621);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(78418);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(19255);
/* harmony import */ var _style_module_scss__WEBPACK_IMPORTED_MODULE_8___default = /*#__PURE__*/__webpack_require__.n(_style_module_scss__WEBPACK_IMPORTED_MODULE_8__);
/* harmony import */ var _page_builder_utils__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(79961);
/* harmony import */ var _lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(75094);








// import CloseIcon from "@components/svg/closeIcon";

function Header({ slogan , children , textColor , iconColor , backGroundColor , isLogoClickable =true , emptyIcon , boxShadow , border , phoneNumberColor , stickyStyle , hideSticky , logoClassName , useChildrenLogo , bannerStyleAsProp , className , useSecondaryLogo =false  }) {
    const { domain , blogPost , routeConfig , showFormModal , locale , defaultLocale , pageType ,  } = (0,_hooks_useDomainContext__WEBPACK_IMPORTED_MODULE_2__/* .useDomainContext */ .w)();
    const { 0: headerHeight , 1: setHeaderHeight  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(null);
    const header = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    const { 0: bannerActive , 1: setBannerActive  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { 0: hidePhoneNumber , 1: setHidePhoneNumber  } = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false);
    const { query , asPath  } = (0,next_router__WEBPACK_IMPORTED_MODULE_4__.useRouter)();
    const bannerTextBlock = domain.textBlocks?.find((textBlock)=>textBlock.position === "banner");
    function showingBanner() {
        if (!bannerTextBlock) return false;
        if (pageType === "page-builder") {
            return !routeConfig?.config?.settings?.preHeaderText;
        }
        return true;
    }
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(()=>{
        let prevHeight = "0";
        const observer = new ResizeObserver(([headerEntry])=>{
            if (header.current) {
                const height = headerEntry.borderBoxSize?.[0]?.blockSize.toFixed(0);
                if (height !== prevHeight) {
                    prevHeight = height;
                    setHeaderHeight(`${height}px`);
                }
            }
        });
        if (header.current) {
            observer.observe(header.current);
        }
        if (bannerTextBlock) {
            setTimeout(()=>{
                setBannerActive(true);
            }, 500);
        }
        if (sessionStorage.getItem(_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .SKIPPED_OPERATION_ID_KEY */ .UG) && asPath.includes("thank-you")) {
            setHidePhoneNumber(true);
        }
        return ()=>{
            if (header.current) {
                observer.unobserve(header.current);
            }
        };
    }, []);
    const logoFromVariantConfig = routeConfig?.templateConfig?.variantConfig?.logo;
    const logoPath = logoFromVariantConfig ?? routeConfig?.config?.settings?.logo ?? domain?.logo?.fullPath;
    const secondaryLogoPath = domain?.secondaryLogo?.fullPath ?? null;
    const callIconUnWrappedImage = routeConfig?.templateConfig?.headerAndFooter?.header?.callIconUnWrappedImage;
    const phoneNumberBlock = /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: "slogan items-center flex",
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_components_shared_proxiedNumber__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
            slogan: slogan,
            textColor: textColor,
            iconColor: iconColor ?? textColor,
            emptyIcon: emptyIcon,
            phoneNumberColor: phoneNumberColor,
            stickyStyle: stickyStyle,
            hideSticky: hideSticky || showFormModal,
            iconPath: callIconUnWrappedImage
        })
    });
    const finalUrl = (0,react__WEBPACK_IMPORTED_MODULE_1__.useMemo)(()=>{
        if (!isLogoClickable) {
            return undefined;
        }
        const homepageHref = (0,_lib_sharedUtils__WEBPACK_IMPORTED_MODULE_5__/* .getHomepageHref */ .$N)(query, locale, defaultLocale);
        if (homepageHref === undefined) {
            return undefined;
        }
        const withQueryParams = (0,_lib_shared_routerQueriesToString__WEBPACK_IMPORTED_MODULE_6__/* .gettingQueriesAsString */ .r)(query, "start", [
            "genericRoute",
            "keyword",
            "category",
            "formTemplate",
            "tool",
            "slug",
            "data",
            "zc",
            "filters",
            "pii-token", 
        ]);
        return `${homepageHref}?${withQueryParams}`;
    }, [
        isLogoClickable,
        query
    ]);
    const variables = routeConfig?.config?.header?.variables;
    const styles = {
        backgroundColor: backGroundColor,
        boxShadow: boxShadow,
        borderBottom: border,
        ...variables ? (0,_page_builder_utils__WEBPACK_IMPORTED_MODULE_7__/* .convertToBreakpointVariables */ .Xz)(variables) : {}
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("header", {
        style: styles,
        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().header)} ${className}`,
        ref: header,
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: `ltrStyle inner py-5 lg:py-4 px-5 flex lg:max-w-7xl mx-auto  lg:px-6 items-center ${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().headerContainer)} `,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().logo)} ${logoClassName ? logoClassName : ""}`,
                        style: {
                            backgroundImage: `url(${useSecondaryLogo ? secondaryLogoPath : logoPath ?? ""})`,
                            width: "auto",
                            height: "auto",
                            backgroundSize: "contain",
                            backgroundRepeat: "no-repeat",
                            backgroundPosition: "center",
                            ...domain.name === "homewarranty.deals" ? {
                                maxWidth: "330px"
                            } : {}
                        },
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("a", {
                            href: finalUrl,
                            "aria-label": `${domain.name} logo`,
                            children: logoPath && !useChildrenLogo ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                src: logoPath,
                                className: "h-auto w-full",
                                alt: `${domain.name} logo`,
                                style: {
                                    visibility: "hidden"
                                },
                                rel: "preload"
                            }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                className: "children:w-full children:h-auto lg:children:h-10",
                                children: children
                            })
                        })
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        children: [
                            blogPost && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: "text-xs lg:flex hidden justify-end text-[#6b6b6b] ",
                                children: "Advertisement"
                            }),
                            !hidePhoneNumber && phoneNumberBlock
                        ]
                    }),
                    headerHeight && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("style", {
                        children: `:root {--header-height: ${headerHeight} }`
                    })
                ]
            }),
            showingBanner() && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: `${(_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().banner)} ${bannerStyleAsProp ?? ""} ${bannerActive ? (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default().active) : ""}`,
                style: {
                    "--banner-background-color": domain?.config?.bannerBgColor,
                    "--banner-text-color": domain?.config?.bannerTextColor
                },
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                    dangerouslySetInnerHTML: {
                        __html: bannerTextBlock?.text ?? ""
                    },
                    className: (_style_module_scss__WEBPACK_IMPORTED_MODULE_8___default()["banner-inner"])
                })
            })
        ]
    });
}


/***/ }),

/***/ 78418:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "r": function() { return /* binding */ gettingQueriesAsString; }
/* harmony export */ });
const gettingQueriesAsString = (query, location, excludeList)=>{
    const initialValue = "";
    return Object.keys(query).reduce(function(previousValue, currentValue, index) {
        const value = query[currentValue];
        if (excludeList?.includes(currentValue)) {
            return previousValue;
        }
        return previousValue + `${index !== 0 ? "&" : ""}${currentValue}=${value}`;
    }, initialValue);
};


/***/ }),

/***/ 79961:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "CA": function() { return /* binding */ extractUrl; },
/* harmony export */   "OZ": function() { return /* binding */ generateGlobalVariables; },
/* harmony export */   "XR": function() { return /* binding */ getFinalFontFamily; },
/* harmony export */   "Xz": function() { return /* binding */ convertToBreakpointVariables; },
/* harmony export */   "Z2": function() { return /* binding */ modifyCSSForElement; },
/* harmony export */   "hJ": function() { return /* binding */ minifyCSS; },
/* harmony export */   "uC": function() { return /* binding */ getFormTemplate; }
/* harmony export */ });
/* unused harmony export breakpoints */
const breakpoints = [
    "sm",
    "md",
    "lg",
    "xl",
    "xxl"
];
// ****** EXAMPLE INPUT ******
// variables = {
//     "titleSize": {
//         "sm": "14px",
//         "md": "16px",
//     },
//     "descriptionSize": "14px",
//     "titleColor": {
//          "sm": "red",
//          "lg": "blue",
//     },
// }
// ****** OUTPUT ******
// breakpointVariables = {
//     "--title-size-sm": "14px",
//     "--title-size-md" : "16px",
//     "--title-size-lg" : "16px",
//     "--title-size-xl" : "16px",
//     "--title-size-xxl" : "16px",
//     "--description-size-sm": "14px",
//     "--description-size-md": "14px",
//     "--description-size-lg": "14px",
//     "--description-size-xl": "14px",
//     "--description-size-xxl": "14px",
//     "--title-color-sm": "red",
//     "--title-color-md": "red",
//     "--title-color-lg": "blue",
//     "--title-color-xl": "blue",
//     "--title-color-xxl": "blue",
// }
/**
 * Convert variables object to css variables with breakpoints handled
 *
 * @param variables - variables object to convert
 * @param namespace - optional namespace to prefix variable names (e.g., "tabs", "accordion")
 */ function convertToBreakpointVariables(variables, namespace) {
    const breakpointVariables = {};
    for (const [key, value] of Object.entries(variables)){
        if (!value) continue;
        // Create variable name with optional namespace prefix
        const varName = namespace ? `${namespace}-${key}` : key;
        if (typeof value === "object") {
            const objValue = value;
            breakpoints.forEach((breakpoint, index)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = objValue[breakpoint] || objValue[breakpoints[index - 1]] || objValue[breakpoints[index - 2]] || objValue[breakpoints[index - 3]] || objValue[breakpoints[index - 4]] || objValue["sm"] || "unset";
            });
        } else {
            breakpoints.forEach((breakpoint)=>{
                breakpointVariables[`--${varName}-${breakpoint}`] = value;
            });
        }
    }
    return breakpointVariables;
}
function generateGlobalVariables(config) {
    const cssVariables = {};
    function recursiveGenerateCSSVariables(obj, prefix = "") {
        for(const key in obj){
            if (key in obj) {
                const value = obj[key];
                if (typeof value !== "string" && value !== null) {
                    recursiveGenerateCSSVariables(value, `${prefix}-${key}`);
                } else {
                    const variableName = `--${prefix}-${key.replace(/([a-z])([A-Z])/g, "$1-$2").toLowerCase()}`;
                    cssVariables[variableName] = value || "unset";
                }
            }
        }
    }
    recursiveGenerateCSSVariables(config, "global");
    return cssVariables;
}
const minifyCSS = (css)=>css.replace(/\n/g, "").replace(/\s\s+/g, " ");
function modifyCSSForElement(cssString, selector) {
    if (!cssString) return "";
    // At-rules that should have selector prepended to their inner rules
    const scopedAtRules = [
        "@media",
        "@supports",
        "@container",
        "@layer"
    ];
    // At-rules that should be kept as-is (no selector modification)
    const globalAtRules = [
        "@keyframes",
        "@-webkit-keyframes",
        "@-moz-keyframes",
        "@font-face",
        "@import",
        "@charset",
        "@namespace",
        "@page", 
    ];
    // Helper to prepend selector to simple CSS rules
    const prependSelectorToRules = (css)=>{
        const rules = css.split("}");
        return rules.map((rule)=>{
            const trimmed = rule.trim();
            if (trimmed === "") return "";
            const braceIndex = trimmed.indexOf("{");
            if (braceIndex === -1) return `${selector} ${trimmed}`;
            const selectorPart = trimmed.substring(0, braceIndex);
            const bodyPart = trimmed.substring(braceIndex);
            const scopedSelectors = selectorPart.split(",").map((s)=>`${selector} ${s.trim()}`).join(", ");
            return `${scopedSelectors} ${bodyPart}`;
        }).join("\n}\n");
    };
    // Find the closing brace that matches an opening brace (handles nesting)
    const findMatchingBrace = (str, startPos)=>{
        let braceCount = 1;
        let pos = startPos;
        while(braceCount > 0 && pos < str.length){
            if (str[pos] === "{") braceCount++;
            if (str[pos] === "}") braceCount--;
            pos++;
        }
        return pos;
    };
    // Find the next at-rule in the string
    const findNextAtRule = (str)=>{
        const allAtRules = [
            ...scopedAtRules,
            ...globalAtRules
        ];
        let earliest = null;
        for (const atRule of allAtRules){
            const index = str.indexOf(atRule);
            if (index !== -1 && (earliest === null || index < earliest.index)) {
                earliest = {
                    index,
                    type: atRule,
                    isScoped: scopedAtRules.includes(atRule)
                };
            }
        }
        return earliest;
    };
    // Recursively process CSS (handles nested at-rules)
    const processCSS = (css)=>{
        let result = "";
        let remaining = css;
        while(remaining.length > 0){
            const nextAtRule = findNextAtRule(remaining);
            if (!nextAtRule) {
                // No more at-rules, process remaining as regular rules
                result += prependSelectorToRules(remaining);
                break;
            }
            // Process any rules before this at-rule
            if (nextAtRule.index > 0) {
                const beforeAtRule = remaining.substring(0, nextAtRule.index);
                result += prependSelectorToRules(beforeAtRule);
            }
            // Find the opening brace for this at-rule
            const openBrace = remaining.indexOf("{", nextAtRule.index);
            if (openBrace === -1) {
                // No brace found (e.g., @import or @charset statement)
                const semicolon = remaining.indexOf(";", nextAtRule.index);
                if (semicolon !== -1) {
                    result += remaining.substring(nextAtRule.index, semicolon + 1);
                    remaining = remaining.substring(semicolon + 1);
                    continue;
                }
                break;
            }
            const atRuleHeader = remaining.substring(nextAtRule.index, openBrace).trim();
            const closeBrace = findMatchingBrace(remaining, openBrace + 1);
            const atRuleContent = remaining.substring(openBrace + 1, closeBrace - 1);
            if (nextAtRule.isScoped) {
                // Scoped at-rules: process inner content recursively
                const processedContent = processCSS(atRuleContent);
                result += `\n${atRuleHeader} {\n${processedContent}\n}\n`;
            } else {
                // Global at-rules: keep content as-is
                result += `\n${atRuleHeader} {\n${atRuleContent}\n}\n`;
            }
            remaining = remaining.substring(closeBrace);
        }
        return result;
    };
    return minifyCSS(processCSS(cssString));
}
const extractUrl = (input)=>{
    const match = input.match(/^url\((.+)\)$/);
    return match ? match[1] : "";
};
const getFormTemplate = (path)=>{
    if (path.includes("/free-consultation/v1")) {
        return "v1";
    }
    if (path.includes("/free-consultation/v2")) {
        return "v2";
    }
    return null;
};
const getFinalFontFamily = (routeConfig, locale, fontFamily)=>{
    const templateGlobalConfig = routeConfig?.templateConfig;
    const fontFamilyFromOtherLanguages = templateGlobalConfig?.variantConfig?.otherLanguagesConfig?.[locale]?.fontFamily;
    const fontFamilyFromMainLanguage = templateGlobalConfig?.theme?.fontFamily?.replace(" ", "");
    if (templateGlobalConfig) {
        return fontFamilyFromOtherLanguages || fontFamilyFromMainLanguage || (locale === "ar" ? "Almarai" : "Poppins");
    } else {
        return fontFamily || (locale === "ar" ? "Almarai" : "Poppins");
    }
};


/***/ }),

/***/ 19255:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"header":"style_header__NnJo8","headerContainer":"style_headerContainer__bfY8J","logo":"style_logo__oPgVZ","banner":"style_banner__nKv8j","close-button":"style_close-button__1RZQB","active":"style_active__DfBCW","banner-inner":"style_banner-inner__pvqcg","preHeader":"style_preHeader__0jNK7"};

/***/ }),

/***/ 4420:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"darkBlue":"#222e59","hover":"#fff5f5","darkRed":"#ae332f","grey":"#eaeaea","stickTitleColor":"#000","stickBtnTxtColor":"#fff","stickBtnBgColor":"#ae332f","stickBtnBorderColor":"#ae332f"};

/***/ })

}]);